export default "__VITE_ASSET__BXo8GsqA__"